import { OperationType } from "static/types";
import { createStore } from "zustand";
import { persist } from "zustand/middleware";

type FxOrderState = {
  from: string;
  to: string;
  operation: null | OperationType;
  quantity: number | "";
  amount: number | "";
  limitPrice: null | number;
  change_type: "amount" | "quantity";
  selectedOfferID: number | null;

  setFrom: (from: string) => void;
  setTo: (to: string) => void;
  setOperation: (operation: OperationType) => void;
  setQuantity: (quantity: number | "") => void;
  setAmount: (amount: number | "") => void;
  setLimitPrice: (limitPrice: number | null) => void;
  setChangeType: (change_type: "amount" | "quantity") => void;
  setSpecialOfferID: (special_offer_id: number | null) => void;

  clear: () => void;
};

export const fxOrderStore = createStore<FxOrderState>()(
  persist(
    (set, get) => ({
      from: "USD",
      to: "AMD",
      operation: null,
      quantity: "",
      amount: "",
      selectedOfferID: null,
      limitPrice: null,
      change_type: "quantity",
      setFrom: (from: string) => set({ from }),
      setTo: (to: string) => set({ to }),
      setOperation: (operation: OperationType) => set({ operation }),
      setQuantity: (quantity: number | "") => set({ quantity }),
      setAmount: (amount: number | "") => set({ amount }),
      setLimitPrice: (limitPrice: number | null) => set({ limitPrice }),
      setChangeType: (change_type: "amount" | "quantity") =>
        set({ change_type }),
      setSpecialOfferID: (selectedOfferID: number | null) =>
        set({ selectedOfferID }),

      clear: () => {
        set({
          from: "USD",
          to: "AMD",
          operation: null,
          quantity: "",
          amount: "",
          limitPrice: null,
          selectedOfferID: null,
        });
      },
    }),
    {
      name: "fx-order",
      version: 2,
      merge: (persistedState, currState) => {
        const {
          from,
          to,
          operation,
          quantity,
          limitPrice,
          amount,
          change_type,
          selectedOfferID,
        } = persistedState as Partial<FxOrderState>;

        return {
          ...currState,
          from: from ?? "USD",
          to: to ?? "AMD",
          operation: operation ?? null,
          quantity: quantity ?? "",
          limitPrice: limitPrice ?? null,
          amount: amount ?? "",
          change_type: change_type ?? "quantity",
          selectedOfferID: selectedOfferID ?? null,
        };
      },
    }
  )
);
